import { Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Link from 'next/link';
import React from 'react';

export const programOffers = [
  {
    id: 1,
    imageUri: '/images/programs/book.png',
    title: '-BOOK-',
    subtitle: 'Private Lessons',
    link: '/programs/private-lessons',
  },
  {
    id: 2,
    imageUri: '/images/programs/explore.png',
    title: '-EXPLORE-',
    subtitle: 'Women’s Programs',
    link: '/programs/women-programs',
  },
  {
    id: 3,
    imageUri: '/images/programs/experience.png',
    title: '-EXPERIENCE-',
    subtitle: 'Club Fitting',
    link: '/programs/club-fitting',
  },
  {
    id: 4,
    imageUri: '/images/programs/find.png',
    title: '-FIND-',
    subtitle: 'Adult Classes',
    link: '/programs/adult-classes',
  },
  {
    id: 5,
    imageUri: '/images/programs/join.png',
    title: '-JOIN-',
    subtitle: 'Junior Programs',
    link: '/programs/junior-programs',
  },
];

const useStyles = makeStyles((theme) => ({
  tileLink: {
    textDecoration: 'none',
  },
  title: {
    fontFamily: 'Playfair Display',
    fontSize: '50px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '58px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '30px',
      lineHeight: '36px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      lineHeight: '24px',
    },
  },
  description: {
    fontFamily: 'Lato',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '36px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  item: {
    height: '216px',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  itemContent: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  itemTitle: {
    fontFamily: 'Playfair Display',
    fontSize: '17px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '27px',
    color: '#FFFFFF',
  },
  itemSubtitle: {
    fontFamily: 'Playfair Display',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '28px',
    color: '#FFFFFF',
  },
}));

function ProgramTabContent({ node }) {
  const classes = useStyles();

  return (
    <Box>
      <Box>
        <Typography className={classes.title}>{node?.title}</Typography>
        <div className={classes.description}>
          <p dangerouslySetInnerHTML={{__html: node?.body}}></p>
        </div>
        
      </Box>
      <Box>
        <Grid
          container
          spacing={3}
          style={{ marginTop: '40px', marginBottom: '40px' }}
        >
          {programOffers.map((offer, i) => (
            <Grid item xs={12} sm={6} md={i < 3 ? 4 : 6} key={offer.id}>
              <Link className={classes.tileLink} href={offer.link}>
                <Box
                  className={classes.item}
                  style={{
                    backgroundImage: `url(${offer.imageUri})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <Box className={classes.itemContent}>
                    <Typography className={classes.itemTitle}>
                      {offer.title}
                    </Typography>
                    <Typography className={classes.itemSubtitle}>
                      {offer.subtitle}
                    </Typography>
                  </Box>
                </Box>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ProgramTabContent;
